export const services = [
  {
    id: 1,
    title: '점성술 리딩',
    description: '서양 점성술로 당신의 탄생 차트를 분석하고 행성의 영향력을 해석합니다',
    image: 'https://public.readdy.ai/ai/img_res/f6fea1260ed7d38373f8aab034f61bfd.jpg',
    icon: 'ri-star-fill',
    emoji: '✨',
    link: '/astrology',
    tokens: 5,
    features: [
      '탄생 차트 완전 분석',
      '행성 위치와 영향력 해석',
      '10년 / 30년 운세 예측',
      '실시간 AI 점성술 상담',
    ],
  },
  {
    id: 2,
    title: '사주팔자 분석',
    description: '동양의 사주팔자로 타고난 운명과 인생의 흐름을 깊이 있게 분석합니다',
    image: 'https://readdy.ai/api/search-image?query=elegant%20astrological%20birth%20chart%20with%20zodiac%20symbols%20and%20planetary%20alignments%20in%20circular%20mandala%20design%20glowing%20golden%20lines%20on%20deep%20purple%20cosmic%20background%20mystical%20fortune%20telling%20visualization&width=600&height=600&seq=service2&orientation=squarish',
    icon: 'ri-yin-yang-line',
    emoji: '☯',
    link: '/four-pillars',
    tokens: 5,
    features: [
      '사주팔자 완전 해석',
      '오행 균형 분석',
      '대운 / 세운 흐름 파악',
      '실시간 AI 사주 상담',
    ],
  },
  {
    id: 3,
    title: '꿈해몽 AI 상담',
    description: '한국 전통 해몽, 동양 오행, 서양 심리학을 결합한 가장 깊이 있는 꿈 풀이',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20dreamscape%20with%20floating%20golden%20moon%20and%20swirling%20indigo%20nebula%20clouds%2C%20surreal%20night%20sky%20filled%20with%20glowing%20dream%20symbols%20and%20celestial%20orbs%2C%20ethereal%20sleep%20consciousness%20visualization%20on%20deep%20purple%20cosmic%20background%2C%20mystical%20dream%20interpretation%20atmosphere&width=800&height=600&seq=service3&orientation=landscape',
    icon: 'ri-moon-fill',
    emoji: '🌙',
    link: '/dream',
    tokens: 5,
    features: [
      '전통 해몽 + 오행 연결 분석',
      '길몽 / 흉몽 즉시 판단',
      '반복 꿈 심리 분석',
      '꿈 일기 자동 저장',
    ],
  },
  {
    id: 4,
    title: 'Destiny GPT — 결정 비서',
    description: '인생의 중대한 결정 앞에서 사주와 오행으로 최적의 타이밍과 방향을 제시하는 AI 결정 비서',
    image: 'https://readdy.ai/api/search-image?query=majestic%20golden%20cosmic%20scales%20of%20fate%20and%20destiny%20floating%20in%20deep%20mystical%20universe%20with%20ancient%20fortune%20symbols%20glowing%20celestial%20light%20dramatic%20dark%20indigo%20background%20representing%20life%20decision%20making%20profound%20wisdom&width=800&height=600&seq=service4destiny&orientation=landscape',
    icon: 'ri-compass-line',
    emoji: '🔮',
    link: '/astrology',
    tokens: 8,
    features: [
      '직장·결혼·창업·이사 6대 결정 분석',
      '사주 오행 기반 최적 타이밍 도출',
      '리스크와 귀인 출현 시기 예측',
      '개인 맞춤 길일(吉日) 추천',
    ],
  },
  {
    id: 5,
    title: '1년 운세 리포트',
    description: '올해(혹은 원하는 해) 월별 운세를 사주 오행 × 년운 기운으로 정밀 분석합니다',
    image: 'https://readdy.ai/api/search-image?query=golden%20celestial%20calendar%20pages%20turning%20in%20ethereal%20cosmic%20space%20fortune%20almanac%20glowing%20charts%20and%20symbols%20floating%20in%20mystical%20deep%20indigo%20nebula%20annual%20year%20fortune%20cycle%20visualization%20elegant%20spiritual&width=800&height=600&seq=service5annual&orientation=landscape',
    icon: 'ri-calendar-2-line',
    emoji: '📅',
    link: '/annual-report',
    tokens: 10,
    features: [
      '12개월 월별 운세 점수 제공',
      '재물·애정·직업·건강·대인 5개 카테고리',
      '최고 / 주의 달 자동 표시',
      '연도별 행운 아이템 추천',
    ],
  },
  {
    id: 6,
    title: '평생 운세 리포트',
    description: '인생 전체 사이클 — 4단계 인생 페이즈와 10년 대운 흐름을 한눈에 파악합니다',
    image: 'https://readdy.ai/api/search-image?query=infinite%20cosmic%20timeline%20spiral%20with%20glowing%20golden%20light%20particles%20traveling%20through%20deep%20universe%20showing%20lifetime%20journey%20and%20destiny%20path%20ethereal%20life%20cycle%20ancient%20fortune%20wheel%20stars%20and%20nebula%20mystical%20profound%20visualization&width=800&height=600&seq=service6lifetime&orientation=landscape',
    icon: 'ri-time-line',
    emoji: '♾',
    link: '/lifetime-report',
    tokens: 15,
    features: [
      '청년·장년·중년·노년 4단계 분석',
      '10년 대운 9사이클 운세 흐름',
      '커리어·재물·인연·건강 정점 시기',
      '평생 강점 및 주의 사항 리포트',
    ],
  },
];
